export default __webpack_public_path__ + "static/media/indonesia.2743ce0b.png";